<template>
    <v-container fluid>
    <field-form v-if="item" @save="save" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" :last-editable-step="lastEditableStep" :allow-editable="true" @cancel="cancelWizard()" @click-step="changeStep">
    
      <v-card
      id="pfid1618821240" class="mb-3">
        <v-row>
          <v-col cols="12" :lg="item.subjects ? 4 : 6">
        <v-card-title>{{$t('campaigns.setup.sender.title')}}</v-card-title>
          <v-card-text>
          <span>{{$t('campaigns.setup.sender.text')}}</span>
        <v-alert v-if="!item.domain.dnsName" type="warning" colored-border border="left" >
          <i18n path="campaigns.setup.sender.error" tag="p">
          <template v-slot:page>
            <router-link :to="{name: 'mailing'}">{{$t('campaigns.setup.sender.setupPage')}}</router-link>
        </template>
          </i18n>    
      </v-alert>
      
        <v-text-field id="pfid1618820968" style="max-width:400px" :label="$t('campaigns.setup.sender.email')" placeholder="news" prepend-icon="$mailing" v-model="fields.from" :suffix="`@${item.domain.dnsName || 'example.com'}`"  class="pr-3" :rules="[rules.required, rules.inbox]"></v-text-field>
        <v-text-field id="pfid1618820971" style="max-width:400px" :label="$t('campaigns.setup.sender.name')" :placeholder="$t('campaigns.setup.sender.name')" prepend-icon="$rename" v-model="fields.friendlyFrom" class="pr-3" ></v-text-field>
        <v-text-field id="pfid1618820973" style="max-width:400px" :label="$t('campaigns.setup.sender.replyTo')" placeholder="news" prepend-icon="$mailing" v-model="fields.replyTo" :suffix="`@${item.domain.dnsName || 'example.com'}`" :rules="[rules.inbox]" class="pr-3"></v-text-field>
        </v-card-text>
          </v-col>
          <!-- LEGACY CAMPAIGNS - disable for new campaigns -->
         <v-col v-if="item.subjects" cols="12" lg="4"> 
        <v-card-title>{{$t('campaigns.setup.subjects.title')}}</v-card-title>
        <v-alert type="warning" border="left" outlined>
          {{ $t('campaigns.setup.subjects.deprecated')}}
        </v-alert>
        <v-card-text>{{$t('campaigns.setup.subjects.text')}}</v-card-text>
        <v-list dense id="pfid1618820997">
          <v-list-item v-for="(s,i) in fields.subjects" :key="i">
            <v-list-item-content>
              <v-text-field v-if="editedSubject == i" dense :placeholder="$t('campaigns.setup.subjects.label')" v-model="fields.subjects[i]"></v-text-field>
              <v-list-item-title v-else>{{s}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row no-gutters class="ma-0 pa-0" justify="end">
              <action-button class="pfcl1618821018" v-if="editedSubject == i" icon="$ok" :tooltip="$t('dialog.confirm')" @click="editedSubject = null"/>
              <action-button class="pfcl1618821022" icon="$remove" :tooltip="$t('dialog.remove')" @click="removeSubject(i)"/>
              <action-button class="pfcl1618821025" icon="$edit" :tooltip="$t('dialog.edit')" @click="editedSubject=i"/>
              </v-row>  
            </v-list-item-action>
              
          </v-list-item>
        </v-list>
        <v-card-actions><v-btn id="pfid1618821038" text @click="addSubject"><v-icon left>$add</v-icon>{{$t('dialog.add')}}</v-btn></v-card-actions>
         </v-col>
        <!-- END OF LEGACY CAMPAIGNS -->

         <v-col cols="12" :lg="item.subjects ? 4 : 6">
        <v-card-title>{{$t('campaigns.setup.message.title')}}</v-card-title>
        <v-card-text>
          <!--
          <v-text-field style="max-width:400px" label="UTM source" placeholder="dreamroi" readonly :value="item.utm.source" ></v-text-field>
          <v-text-field style="max-width:400px" label="UTM medium" placeholder="email"  readonly :value="item.utm.medium" ></v-text-field>
          -->
          <v-text-field id="pfid1618821281" style="max-width:400px" :label="$t('campaigns.setup.message.utmCampaign')" :placeholder="item.name" v-model="fields.utm.campaign" class="pr-3"></v-text-field>
          <!-- <label class="v-label" for="textVersion">Generate text version of the message</label> -->
          <!--
          <v-switch id="pfid1618821285" name="textVersion" v-model="fields.textVersion" :label="$t('campaigns.setup.message.textVersion')" />
          -->
          <!--
          <v-text-field style="max-width:400px" label="Default sale" placeholder="20" suffix="%" v-model.number="fields.templateSpecs.defaultSale" ></v-text-field>
          -->

          <v-text-field id="pfid1623767727"  style="max-width:400px" :label="$t('campaigns.setup.message.saleTemplate')" v-model="fields.templateSpecs.saleTemplate" class="pr-3"></v-text-field>
          <v-text-field id="pfid1623767727"  style="max-width:400px" :label="$t('campaigns.setup.message.originalPriceTemplate')" v-model="fields.templateSpecs.originalPriceTemplate" class="pr-3"></v-text-field>
          </v-card-text>
            <v-subheader>{{$t('campaigns.setup.message.sale.title')}}</v-subheader>
          <v-card-text>
          <v-slider id="pfid1618821296" thumb-label="always" :thumb-size="24" min="0" max="100" v-model.number="fields.templateSpecs.defaultSale" persistent-hint  :hint="$t('campaigns.setup.message.sale.text')" />
        </v-card-text>
            <v-subheader>{{$t('campaigns.setup.message.stripDesc.title')}}</v-subheader>
        <v-card-text>
          <v-slider id="pfid1618821301" thumb-label="always" :thumb-size="24" min="0" max="150" v-model.number="fields.templateSpecs.stripDescription" persistent-hint :hint="$t('campaigns.setup.message.stripDesc.text')"  />
        </v-card-text>
         </v-col>
        </v-row>
      </v-card>
      <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{$t('dialog.unsaved.text')}}
    </confirm-dialog>
    </field-form>
    <v-skeleton-loader v-else type="card,card,card" />
    </v-container>
</template>
<script>

  import EntityForm from "@/mixins/entity-form"
  import Wizards from "@/mixins/wizards"
  import ConfirmLeave from '@/mixins/confirm-leave'
  //import Formatters from "@/mixins/formatters"

  export default {
    mixins: [ConfirmLeave, EntityForm, Wizards,  /*Formatters*/],
    name: 'Setup',
    data() {
      return {
        endpoint: 'campaigns',
        //subjects: [],
        editedSubject: null,
        fields: {
          from: null,
          friendlyFrom: null,
          replyTo: null,
          subjects: null,
          textVersion: null,
          templateSpecs: {},
          templateSpecsNew: {},
          templateSpecsCategories: [],
          utm: {}
        }
      };
    },
    computed: {
      wizardParams() {
        let p = {
        };
        if(this.item) {
          p.medium = this.item.medium?.toLowerCase() || 'email';
        }
        return p;
      },
    },
    watch: {

      item() {
        // confuses confirm leave
        // this.initFields();
      }
    
    },
    methods: {
      initFields() {
        // confuses confirm-leave, do not use
        if(this.item && !this.item.subjects) {
          this.fields.subjects = [];
        }
        if(this.item && !this.item.templateSpecs){
          this.fields.templateSpecs = {};
        }
      },
      async prepareFields() {
        if(this.fields.replyTo == '') {
          this.fields.replyTo = null;
        }
        if(this.fields.friendlyFrom == '') {
          this.fields.friendlyFrom = null;
        }

        // only for legacy campaigns
        if(this.item.subjects && (!this.fields.subjects || this.fields.subjects.length == 0)) {
          this.$store.dispatch('ui/notify', { error: true, text: this.$t('campaigns.setup.subjects.error')})
          return false;
        }


        if(this.item.subjects) {
        /* LEGACY CAMPAIGNS */
        let cspecs = (field) => {
          if(this.fields.templateSpecs[field] != this.item.templateSpecs[field]) {           
              this.fields.templateSpecsNew[field] = this.fields.templateSpecs[field];
              this.fields.templateSpecsCategories.forEach(c => {
              c.specs[field] = this.fields.templateSpecs[field];
              })
          }
          };
          cspecs('saleTemplate');
          cspecs('originalPriceTemplate');
          cspecs('defaultSale');
          cspecs('stripDescription');
        } else {
          let cvpu = [];
          /* CAMPAIGN VARIANTS */
          this.item.variants.forEach(variant => {
            let v = { 
              id: variant.id, 
              templateSpecs: {...variant.templateSpecs}, 
              templateSpecsNew: {...variant.templateSpecsNew}, 
              templateSpecsCategories: JSON.parse(JSON.stringify(variant.templateSpecsCategories))
            };
            ['saleTemplate','originalPriceTemplate', 'defaultSale', 'stripDescription'].forEach(field => {
              if(this.fields.templateSpecs[field] != this.item.templateSpecs[field]) {           
                
                v.templateSpecs[field] = this.fields.templateSpecs[field];
                v.templateSpecsNew[field] = this.fields.templateSpecs[field];
                v.templateSpecsCategories.forEach(c => {
                  c.specs[field] = this.fields.templateSpecs[field];
                })
              }
            });
            cvpu.push(this.$store.dispatch('variants/updateVariant', v));
          })
          await Promise.all(cvpu);
        }
        
        /* not working better to initialize the campaign correctly
        if(this.fields.subjects.length == 0) {
          this.fields.subjects = null;
        }
        if(this.fields.templateSpecs.defaultSale == 0) {
          console.debug(`setting default sale to null`);
          this.fields.templateSpecs.defaultSale = null;
        }
        if(this.fields.templateSpecs.stripDescription == 0) {
          this.fields.templateSpecs.stripDescription = null;
        }
        */
       return true;
      },
      
      addSubject() {
        if(!this.fields.subjects) {
          this.fields.subjects = [];
        }
        this.fields.subjects.push(null);
        this.editedSubject = this.fields.subjects.length - 1;
        this.dirty = true;
      },
      removeSubject(i) {
        this.fields.subjects.splice(i, 1);
        this.dirty = true;
      },
      beforeSave() {
        this.dirty = false;
      }
    },
    created() {
      this.$store.commit('ui/wizard', {value: true });
      this.setLastEditableStep();
      // confuses confirm-leave
      //this.initFields();
    }
  }
</script>